export type AdUnitDimension = Array<[number, number] | 'fluid'>;
export const AdConfig = {
  banner: {
    placementName: 'StickySmall',
    mlibDimension: { height: 50, width: 320 },
    googleAdDimension: [[320, 50], [320, 60], [300, 50], [300, 60], 'fluid'] as AdUnitDimension,
    containerDimension: { height: 60, width: 320 }
  },
  mrec: {
    placementName: 'InArticleMedium',
    mlibDimension: { height: 250, width: 300 },
    googleAdDimension: [
      [300, 250],
      [300, 260],
      [320, 250],
      [320, 260],
      [336, 280],
      'fluid'
    ] as AdUnitDimension,
    containerDimension: { height: 300, width: 336 }
  },
  instream: {
    placementName: 'InstreamVideo',
    mlibDimension: { height: 250, width: 300 },
    googleAdDimension: [],
    containerDimension: { height: 290, width: 320 }
  },
  interscrollar: {
    placementName: 'InArticleMedium',
    googleAdDimension: [[300, 600], [320, 480], 'fluid'] as AdUnitDimension,
    containerDimension: { height: 600, width: 336 }
  }
};

// const BASE_AD_PATH = '/22029514685/TracfonePortal';
const BASE_AD_PATH = '/23059745623/TracfonePortal';

export const AdPaths = {
  BANNER_ATF: `${BASE_AD_PATH}_Banner_ATF`,
  BANNER_STICKY: `${BASE_AD_PATH}_Banner_Sticky`,
  MREC_INFEED: `${BASE_AD_PATH}_MREC_Infeed`,
  BANNER_INFEED: `${BASE_AD_PATH}_Banner_Infeed`,
  MREC_ATF: `${BASE_AD_PATH}_MREC_ATF`
};

const GPT_ID = '/23059745623';
export const AdPathsForSpaces = {
  tracfportal: {
    HOME_MREC_TOP: `${GPT_ID}/tracfoneportal_mrec_atf/ele_home_mrec_top`,
    HOME_MREC_MID: `${GPT_ID}/tracfoneportal_mrec_infeed/ele_home_mrec_mid`,
    HOME_STICKY: `${GPT_ID}/tracfoneportal_banner_sticky/ele_home_sticky`,
    DETAIL_MREC_TOP: `${GPT_ID}/tracfoneportal_mrec_atf/ele_detail_mrec_top`,
    DETAIL_MREC_MID: `${GPT_ID}/tracfoneportal_mrec_infeed/ele_detail_mrec_mid`,
    DETAIL_STICKY: `${GPT_ID}/tracfoneportal_banner_sticky/ele_detail_sticky`
  },
  spaces_maosp: {
    BANNER_ATF: `${GPT_ID}/spaces_maosp/ele_detail_banner_top`,
    HOME_MREC_TOP: `${GPT_ID}/spaces_maosp/ele_home_mrec_top`,
    HOME_MREC_MID: `${GPT_ID}/spaces_maosp/ele_home_mrec_mid`,
    HOME_STICKY: `${GPT_ID}/spaces_maosp/ele_home_sticky`,
    DETAIL_MREC_TOP: `${GPT_ID}/spaces_maosp/ele_detail_mrec_top`,
    DETAIL_MREC_MID: `${GPT_ID}/spaces_maosp/ele_detail_mrec_mid`,
    DETAIL_STICKY: `${GPT_ID}/spaces_maosp/ele_detail_sticky`
  },
  spaces_tracfmoto: {
    BANNER_ATF: `${GPT_ID}/spaces_tracfmoto/ele_detail_banner_top`,
    HOME_MREC_TOP: `${GPT_ID}/spaces_tracfmoto/ele_home_mrec_top`,
    HOME_MREC_MID: `${GPT_ID}/spaces_tracfmoto/ele_home_mrec_mid`,
    HOME_STICKY: `${GPT_ID}/spaces_tracfmoto/ele_home_sticky`,
    DETAIL_MREC_TOP: `${GPT_ID}/spaces_tracfmoto/ele_detail_mrec_top`,
    DETAIL_MREC_MID: `${GPT_ID}/spaces_tracfmoto/ele_detail_mrec_mid`,
    DETAIL_STICKY: `${GPT_ID}/spaces_tracfmoto/ele_detail_sticky`
  },
  SW_moto: {
    BANNER_ATF: `${GPT_ID}/LP_SwishmeMoto/ele_home_sticky`,
    HOME_MREC_TOP: `${GPT_ID}/LP_SwishmeMoto/ele_home_mrec_top`,
    HOME_MREC_MID: `${GPT_ID}/LP_SwishmeMoto/ele_home_mrec_mid`,
    HOME_STICKY: `${GPT_ID}/LP_SwishmeMoto/ele_home_sticky`,
    DETAIL_MREC_TOP: `${GPT_ID}/LP_SwishmeMoto/ele_detail_mrec_top`,
    DETAIL_MREC_MID: `${GPT_ID}/LP_SwishmeMoto/ele_detail_mrec_mid`,
    DETAIL_STICKY: `${GPT_ID}/LP_SwishmeMoto/ele_detail_sticky`
  },
  SW_tracfmoto: {
    HOME_MREC_TOP: `${BASE_AD_PATH}/LP_SwishmeTracfoneMoto/ele_home_mrec_top`,
    HOME_MREC_MID: `${BASE_AD_PATH}/LP_SwishmeTracfoneMoto/ele_home_mrec_mid`,
    HOME_STICKY: `${BASE_AD_PATH}/LP_SwishmeTracfoneMoto/ele_home_sticky`,
    DETAIL_MREC_TOP: `${BASE_AD_PATH}/LP_SwishmeTracfoneMoto/ele_detail_mrec_top`,
    DETAIL_MREC_MID: `${BASE_AD_PATH}/LP_SwishmeTracfoneMoto/ele_detail_mrec_mid`,
    DETAIL_STICKY: `${BASE_AD_PATH}/LP_SwishmeTracfoneMoto/ele_detail_sticky`
  }
};
